export default __webpack_public_path__ + "static/media/location.58f71270.svg";